import styled from 'styled-components'

import { helpers } from 'styles'

export const Path = styled.code`
	color: ${helpers.color.text};
	background-color: transparent;
	border-radius: 0;

	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`
